import React from 'react';
import { Header, Title } from './styles';
import Timeline from 'src/Components/Common/Timeline/Timeline';
import ChangeLog from './ChangeLog';
import { useQuery } from 'react-query';
import { ticketsService } from 'src/Utils/ticketsService';
import Skeleton from 'react-loading-skeleton';
import CollapsableSection from 'src/Components/Common/CollapsableSection/CollapsableSection';
export default function ChangeHistory(_a) {
    var ticket = _a.ticket;
    var ticketAuditLogs = useQuery(['ticket-audit-logs', ticket.updated_at], function () { return ticketsService.getTicketAuditLogs(ticket.id); }, {
        enabled: !!(ticket === null || ticket === void 0 ? void 0 : ticket.id),
    }).data;
    var content = ticketAuditLogs ? (React.createElement(Timeline, { timelineItems: ticketAuditLogs.map(function (item) { return ({
            content: React.createElement(ChangeLog, { audit: item }),
            key: item.id,
        }); }) })) : (Array(4)
        .fill(0)
        .map(function (_, index) { return (React.createElement("div", { key: index },
        React.createElement(Skeleton, { height: "10px", width: "200px" }),
        React.createElement(Skeleton, { height: "10px", width: "100px" }),
        React.createElement(Skeleton, { height: "10px", width: "50px" }))); }));
    var header = (React.createElement(Header, null,
        React.createElement(Title, null, "Historial de actividad")));
    return (React.createElement(CollapsableSection, { style: {
            marginTop: '24px',
        }, header: header, defaultOpen: true }, content));
}
